module.exports = __webpack_public_path__ + "static/media/img_simulation_assessment_info_arlips.00dc7d90.jpg";